/*global _ */
import props from './props'
import InputMixin from '../../../../mixins/form/input'
import {nil} from '../../../../lib/formatters'

const mixins = [InputMixin]

export default {
  name: 're-input-button',
  mixins,
  props,
  data() {
    return {
      valueEmitted: false
    }
  },
  computed: {
    inputAttrs() {
      return {
        ...this.inputAttr || {},
        disabled: this.isButtonDisabled,
        readonly: this.isButtonDisabled,
      }
    },
    buttonAttrs() {
      return {
        ...this.buttonAttr || {},
        disabled: this.isButtonDisabled,
      }

    },
    resetButtonAttrs() {
      return {
        ...this.resetButtonAttr || {}
      }
    },
    isButtonDisabled() {
      return this.isResetNeeded && this.valueEmitted && this.disableInputOnApply
    },
    isButtonVisible() {
      return !this.isResetButtonVisible
    },
    isResetButtonVisible() {
      return this.isResetNeeded && this.valueEmitted
    },
    containerClasses() {
      return [
        this.containerClass
      ]
    },
    inputClasses() {
      return [
        {
          disabled: this.isButtonDisabled
        }
      ]
    },
    buttonClasses() {
      return [
        this.buttonClass
      ]
    },
    resetButtonClasses() {
      return [
        this.resetButtonClass
      ]
    },
  },
  created() {
    if (this.model) {
      this.valueEmitted = true
    }
  },
  methods: {
    getLabelExtraClasses() {
      return ['re-input-button-label']
    },
    async emitValueOnKey(e) {
      if (this.applyOnKeys) {
        await this.$nextTick()
        this.emitValue()
      }
    },
    emitValue() {
      this.model = this.innerValue
      if (!nil(this.innerValue)) {
        this.valueEmitted = true
      }
    },
    resetInput() {
      this.valueEmitted = false
      if (this.clearOnReset) {
        this.innerValue = this.resetValue
        if (this.applyOnReset) {
          this.model = this.innerValue
        }
      }
    },
  }
}
